export default __webpack_public_path__ + "static/media/btcswe.9d4c73dd.png";